import { defineMessage } from "react-intl";

// Types

export const MENUS_ITEMS_TYPE_VALUE_LINK = "link";
export const MENUS_ITEMS_TYPE_VALUE_OBJECT = "object";

export const MENUS_ITEMS_TYPES = {
  [MENUS_ITEMS_TYPE_VALUE_LINK]: {
    id: MENUS_ITEMS_TYPE_VALUE_LINK,
  },
  [MENUS_ITEMS_TYPE_VALUE_OBJECT]: {
    id: MENUS_ITEMS_TYPE_VALUE_OBJECT,
  },
};

export const MENUS_ITEMS_TYPE_LIST = Object.values(MENUS_ITEMS_TYPES);

export const MENUS_ITEMS_TYPE_MESSAGE = defineMessage({
  defaultMessage:
    "{menuItemType, select, link {Lien} object {Objet} other {{menuItemType}}}",
});

// Types d’objets supportés

export const MENUS_ITEMS_OBJECT_TYPE_VALUE_POST = "post";
export const MENUS_ITEMS_OBJECT_TYPE_VALUE_POST_CATEGORY = "post_category";

export const MENUS_ITEMS_OBJECT_TYPES = {
  [MENUS_ITEMS_OBJECT_TYPE_VALUE_POST]: {
    id: MENUS_ITEMS_OBJECT_TYPE_VALUE_POST,
  },
  [MENUS_ITEMS_OBJECT_TYPE_VALUE_POST_CATEGORY]: {
    id: MENUS_ITEMS_OBJECT_TYPE_VALUE_POST_CATEGORY,
  },
};

export const MENUS_ITEMS_OBJECT_TYPE_LIST = Object.values(
  MENUS_ITEMS_OBJECT_TYPES,
);

export const MENUS_ITEMS_OBJECT_TYPE_MESSAGE = defineMessage({
  defaultMessage:
    "{menuItemObjectType, select, post {{postType, select, page {Page} article {Article} other {{postType}}}} post_category {{postType, select, page {Catégorie de page} article {Catégorie d’article} other {{postType}}}} other {{menuItemType}}}",
});

// Roles

export const MENUS_ITEMS_ROLE_VALUE_HIGHLIGHTED = "highlighted";

/** @type {Record<string,  {id: string, label: import("react-intl").MessageDescriptor, description: import("react-intl").MessageDescriptor}>} */
export const MENUS_ITEMS_ROLES = {
  [MENUS_ITEMS_ROLE_VALUE_HIGHLIGHTED]: {
    id: MENUS_ITEMS_ROLE_VALUE_HIGHLIGHTED,
    label: defineMessage({
      defaultMessage: "Mise en avant",
      description: "Menu role label",
    }),
    description: defineMessage({
      defaultMessage: "Le menu sera mis en avant",
      description: "Menu role description",
    }),
  },
};

export const MENUS_ITEMS_ROLE_LIST = Object.values(MENUS_ITEMS_ROLES);
